export const ONBOARDING_INCOMPLETE_COOKIE_KEY = 'onboarding_incomplete'
export const FIRST_LOGIN_COOKIE_KEY = 'first_login'
